import { useEffect, useState } from 'react';

/**
 * Calculates the width of the specified text.
 */
export const useTextWidth = (text: string): number => {
  const [width, setWidth] = useState(0);

  // TODO: we may want to consider switching this to a canvas-based approach as described in
  // https://stackoverflow.com/a/21015393. We may also want to implement a little bit of caching
  // to avoid re-computing the same text repeatedly.
  useEffect(() => {
    // create temporary element to get the width of the selected value
    const element = document.createElement('span');
    document.body.appendChild(element);

    // Do not wrap text, so we get an accurate width.
    element.style.whiteSpace = 'nowrap';

    // Zero height with inline-block should enable us to get the proper width without
    // any risk of the hidden content changing the height of the document, which is
    // needed because visibility set to hidden only changes visibility NOT layout.
    element.style.visibility = 'hidden';
    element.style.display = 'inline-block';
    element.style.height = `0px`;

    element.textContent = text;
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setWidth(element.getBoundingClientRect().width);

    document.body.removeChild(element);
  }, [text]);

  return width;
};
